import React from "react";

export default function FieldRow({ label, value, onCopy }) {
  const displayValue =
    value === null || value === undefined || value === "" ? "—" : String(value);

  return (
    <div
      onClick={() => onCopy(displayValue)}
      title="Кликни, чтобы скопировать"
      style={{
        display: "flex",
        justifyContent: "space-between",
        gap: "0.75rem",
        padding: "0.25rem 0.4rem",
        borderRadius: "0.4rem",
        cursor: displayValue === "—" ? "default" : "pointer",
        fontSize: "0.8rem",
      }}
    >
      <span style={{ color: "#94a3b8" }}>{label}</span>
      <span
        style={{
          color: "#0f172a",
          fontFamily: "SFMono-Regular, Menlo, Monaco, Consolas, monospace",
          maxWidth: "65%",
          textAlign: "right",
          wordBreak: "break-all",
        }}
      >
        {displayValue}
      </span>
    </div>
  );
}
